import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/[locale]/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalContentProvider"] */ "/vercel/path0/apps/web/src/app/[locale]/GlobalContentProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetScrollbarWidthVariable"] */ "/vercel/path0/apps/web/src/components/ui/set-scrollbar-width-variable/SetScrollbarWidthVariable.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/fonts.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/GlobalWidgetStyles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/lib/accessibility/audioEyeScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ABTestingScript"] */ "/vercel/path0/apps/web/src/lib/analytics/ABTesting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewportMetaClient"] */ "/vercel/path0/apps/web/src/lib/scripts/ViewportMetaClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
